import React from 'react'
import { Image } from '@heroui/react'
import { buscarNombrePlataforma, analizarURL } from '../DiccionarioEnlaces'

// Función para extraer el nombre de la página de una URL usando el diccionario
const extraerNombrePagina = (url) => {
  if (!url) return ''
  
  try {
    // Usar la función analizarURL que es más completa
    const analisis = analizarURL(url)
    
    if (analisis.nombre && analisis.nombre !== analisis.dominio) {
      return analisis.nombre
    }
    
    // Fallback: usar solo buscarNombrePlataforma con el dominio
    return buscarNombrePlataforma(analisis.dominio)
  } catch (error) {
    // Si hay error al parsear la URL, retornar cadena vacía
    return ''
  }
}

// Componente para el icono de TikTok SVG
const TikTokIcon = ({ className = "" }) => (
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    viewBox="0 0 48 48" 
    width="1em" 
    height="1em"
    className={className}
  >
    <path fill="#3dd9eb" d="M20,37c2.761,0,5-2.239,5-5v-1v-1V6.07h5.208c-0.031-0.14-0.072-0.276-0.097-0.419H30.11 c-0.044-0.248-0.076-0.495-0.099-0.746V4.07H23V28v1v1c0,2.761-2.239,5-5,5c-0.864,0-1.665-0.239-2.375-0.625 C16.473,35.931,18.103,37,20,37z"/>
    <path fill="#f55376" d="M33.718,11.407c-0.797-1.094-1.364-2.367-1.607-3.756H32.11c-0.044-0.248-0.076-0.495-0.099-0.746 V6.07h-1.803C30.699,8.252,31.969,10.132,33.718,11.407z"/>
    <path fill="#f55376" d="M18,25c-2.761,0-5,2.239-5,5c0,1.897,1.069,3.527,2.625,4.375C15.239,33.665,15,32.864,15,32 c0-2.761,2.239-5,5-5c0.343,0,0.677,0.035,1,0.101v-7.05C20.669,20.023,20.338,20,20,20s-0.669,0.023-1,0.05v5.05 C18.677,25.035,18.343,25,18,25z"/>
    <path fill="#3dd9eb" d="M36.257,13.783c0.867,0.541,1.819,0.908,2.806,1.131v-0.376v-0.002v-1.381 c-1.7,0.003-3.364-0.473-4.806-1.373c-0.186-0.116-0.361-0.247-0.538-0.376C34.406,12.351,35.263,13.163,36.257,13.783z"/>
    <path fill="#3dd9eb" d="M19,20.05v-2C18.669,18.023,18.338,18,18,18c-6.627,0-12,5.373-12,12 c0,3.824,1.795,7.222,4.581,9.419C8.969,37.377,8,34.804,8,32C8,25.71,12.842,20.56,19,20.05z"/>
    <path fill="#f55376" d="M39.062,14.914v4.733c-3.375,0-6.501-1.071-9.052-2.894L30.013,30l-0.014-0.018 C29.999,29.988,30,29.994,30,30c0,6.627-5.373,12-12,12c-2.804,0-5.377-0.969-7.419-2.581C12.778,42.205,16.176,44,20,44 c6.627,0,12-5.373,12-12c0-0.006-0.001-0.012-0.001-0.018L32.013,32l-0.002-13.248c2.551,1.823,5.677,2.894,9.052,2.894v-5.108 v-0.002v-1.381C40.385,15.157,39.717,15.061,39.062,14.914z"/>
    <path fill="#2100c4" d="M30,30c0-0.006-0.001-0.012-0.001-0.018L30.013,30l-0.002-13.248 c2.551,1.823,5.677,2.894,9.052,2.894v-4.733c-0.987-0.223-1.939-0.59-2.806-1.131c-0.994-0.62-1.851-1.432-2.538-2.376 c-1.75-1.275-3.019-3.155-3.51-5.337H25V30v1v1c0,2.761-2.239,5-5,5c-1.897,0-3.527-1.069-4.375-2.625 C14.069,33.527,13,31.897,13,30c0-2.761,2.239-5,5-5c0.343,0,0.677,0.035,1,0.101v-5.05C12.842,20.56,8,25.71,8,32 c0,2.804,0.969,5.377,2.581,7.419C12.623,41.031,15.196,42,18,42C24.627,42,30,36.627,30,30z"/>
  </svg>
)

// Lista de iconos disponibles (copiada desde PerfilPublico.jsx)
const iconosDisponibles = [
  // Redes sociales principales
  { id: 'facebook', clase: 'fab fa-facebook', nombre: 'Facebook', tipo: 'fontawesome' },
  { id: 'instagram', clase: 'fab fa-instagram', nombre: 'Instagram', tipo: 'fontawesome' },
  { id: 'twitter', clase: 'fab fa-twitter', nombre: 'Twitter', tipo: 'fontawesome' },
  { id: 'linkedin', clase: 'fab fa-linkedin', nombre: 'LinkedIn', tipo: 'fontawesome' },
  { id: 'whatsapp', clase: 'fab fa-whatsapp', nombre: 'WhatsApp', tipo: 'fontawesome' },
  { id: 'youtube', clase: 'fab fa-youtube', nombre: 'YouTube', tipo: 'fontawesome' },
  { id: 'tiktok', nombre: 'TikTok', tipo: 'svg', componente: TikTokIcon },
  { id: 'pinterest', clase: 'fab fa-pinterest', nombre: 'Pinterest', tipo: 'fontawesome' },
  { id: 'snapchat', clase: 'fab fa-snapchat', nombre: 'Snapchat', tipo: 'fontawesome' },
  { id: 'telegram', clase: 'fab fa-telegram', nombre: 'Telegram', tipo: 'fontawesome' },
  { id: 'discord', clase: 'fab fa-discord', nombre: 'Discord', tipo: 'fontawesome' },
  { id: 'twitch', clase: 'fab fa-twitch', nombre: 'Twitch', tipo: 'fontawesome' },
  { id: 'reddit', clase: 'fab fa-reddit', nombre: 'Reddit', tipo: 'fontawesome' },
  { id: 'spotify', clase: 'fab fa-spotify', nombre: 'Spotify', tipo: 'fontawesome' },
  
  // Plataformas profesionales
  { id: 'behance', clase: 'fab fa-behance', nombre: 'Behance', tipo: 'fontawesome' },
  { id: 'dribbble', clase: 'fab fa-dribbble', nombre: 'Dribbble', tipo: 'fontawesome' },
  { id: 'github', clase: 'fab fa-github', nombre: 'GitHub', tipo: 'fontawesome' },
  { id: 'medium', clase: 'fab fa-medium', nombre: 'Medium', tipo: 'fontawesome' },
  { id: 'dev', clase: 'fab fa-dev', nombre: 'Dev.to', tipo: 'fontawesome' },
  
  // Tiendas y ecommerce
  { id: 'amazon', clase: 'fab fa-amazon', nombre: 'Amazon', tipo: 'fontawesome' },
  { id: 'etsy', clase: 'fab fa-etsy', nombre: 'Etsy', tipo: 'fontawesome' },
  { id: 'ebay', clase: 'fab fa-ebay', nombre: 'eBay', tipo: 'fontawesome' },
  { id: 'store', clase: 'fas fa-store', nombre: 'Tienda Online', tipo: 'fontawesome' },
  
  // Otros servicios
  { id: 'paypal', clase: 'fab fa-paypal', nombre: 'PayPal', tipo: 'fontawesome' },
  { id: 'stripe', clase: 'fab fa-stripe-s', nombre: 'Stripe', tipo: 'fontawesome' },
  { id: 'apple', clase: 'fab fa-apple', nombre: 'Apple', tipo: 'fontawesome' },
  { id: 'google', clase: 'fab fa-google', nombre: 'Google', tipo: 'fontawesome' },
  { id: 'microsoft', clase: 'fab fa-microsoft', nombre: 'Microsoft', tipo: 'fontawesome' },
  { id: 'skype', clase: 'fab fa-skype', nombre: 'Skype', tipo: 'fontawesome' },
  { id: 'video', clase: 'fas fa-video', nombre: 'Videoconferencia', tipo: 'fontawesome' },
  { id: 'vimeo', clase: 'fab fa-vimeo', nombre: 'Vimeo', tipo: 'fontawesome' },
  
  // Iconos generales
  { id: 'email', clase: 'fas fa-envelope', nombre: 'Email', tipo: 'fontawesome' },
  { id: 'phone', clase: 'fas fa-phone', nombre: 'Teléfono', tipo: 'fontawesome' },
  { id: 'globe', clase: 'fas fa-globe', nombre: 'Sitio Web', tipo: 'fontawesome' },
  { id: 'link', clase: 'fas fa-link', nombre: 'Enlace', tipo: 'fontawesome' },
  { id: 'shopping', clase: 'fas fa-shopping-cart', nombre: 'Tienda', tipo: 'fontawesome' },
  { id: 'briefcase', clase: 'fas fa-briefcase', nombre: 'Trabajo', tipo: 'fontawesome' },
  { id: 'camera', clase: 'fas fa-camera', nombre: 'Fotografía', tipo: 'fontawesome' },
  { id: 'music', clase: 'fas fa-music', nombre: 'Música', tipo: 'fontawesome' },
  { id: 'film', clase: 'fas fa-video', nombre: 'Video', tipo: 'fontawesome' },
  { id: 'gamepad', clase: 'fas fa-gamepad', nombre: 'Juegos', tipo: 'fontawesome' },
  { id: 'book', clase: 'fas fa-book', nombre: 'Blog', tipo: 'fontawesome' },
  { id: 'heart', clase: 'fas fa-heart', nombre: 'Favoritos', tipo: 'fontawesome' },
  { id: 'home', clase: 'fas fa-home', nombre: 'Inicio', tipo: 'fontawesome' },
  { id: 'star', clase: 'fas fa-star', nombre: 'Destacado', tipo: 'fontawesome' }
]

// Función para renderizar iconos (FontAwesome o SVG personalizado)
export const renderIcon = (iconoId, className = "") => {
  const icono = iconosDisponibles.find(i => i.id === iconoId)
  
  if (!icono) {
    // Si no se encuentra, buscar por clase (compatibilidad hacia atrás)
    const iconoPorClase = iconosDisponibles.find(i => i.clase === iconoId)
    if (iconoPorClase) {
      return <i className={`${iconoPorClase.clase} ${className}`}></i>
    }
    // Fallback para iconos antiguos (emojis y texto)
    return <span className={className}>{iconoId}</span>
  }
  
  if (icono.tipo === 'svg' && icono.componente) {
    const IconoSVG = icono.componente
    return <IconoSVG className={className} />
  } else {
    return <i className={`${icono.clase} ${className}`}></i>
  }
}

// Divisas disponibles (copiadas desde PerfilPublico.jsx)
const divisas = [
  { codigo: 'USD', nombre: 'Dólar Estadounidense', simbolo: '$' },
  { codigo: 'EUR', nombre: 'Euro', simbolo: '€' },
  { codigo: 'MXN', nombre: 'Peso Mexicano', simbolo: '$' },
  { codigo: 'ARS', nombre: 'Peso Argentino', simbolo: '$' },
  { codigo: 'COP', nombre: 'Peso Colombiano', simbolo: '$' },
  { codigo: 'PEN', nombre: 'Sol Peruano', simbolo: 'S/' },
  { codigo: 'CLP', nombre: 'Peso Chileno', simbolo: '$' },
  { codigo: 'BRL', nombre: 'Real Brasileño', simbolo: 'R$' },
  { codigo: 'UYU', nombre: 'Peso Uruguayo', simbolo: '$' },
  { codigo: 'BOB', nombre: 'Boliviano', simbolo: 'Bs' },
  { codigo: 'GTQ', nombre: 'Quetzal Guatemalteco', simbolo: 'Q' },
  { codigo: 'CRC', nombre: 'Colón Costarricense', simbolo: '₡' },
  { codigo: 'PAB', nombre: 'Balboa Panameño', simbolo: 'B/.' },
  { codigo: 'HNL', nombre: 'Lempira Hondureño', simbolo: 'L' },
  { codigo: 'NIO', nombre: 'Córdoba Nicaragüense', simbolo: 'C$' },
  { codigo: 'VES', nombre: 'Bolívar Venezolano', simbolo: 'Bs.S' },
  { codigo: 'GBP', nombre: 'Libra Esterlina', simbolo: '£' },
  { codigo: 'CAD', nombre: 'Dólar Canadiense', simbolo: 'C$' }
]

// Función para formatear precios
export const formatearPrecio = (precio, codigoDivisa) => {
  if (!precio || !codigoDivisa) return ''
  
  const divisa = divisas.find(d => d.codigo === codigoDivisa)
  if (!divisa) return `${precio} ${codigoDivisa}`
  
  // Formatear el número con comas para miles
  const precioFormateado = parseFloat(precio).toLocaleString('es-ES', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2
  })
  
  return `${divisa.simbolo}${precioFormateado}`
}

// Componente base que puede ser extendido por todos los diseños
export const ComponenteBaseEnlace = ({ 
  enlace, 
  estilosMiniatura = false, 
  esPreview = false,
  className = "",
  onClick,
  children
}) => {
  const handleClick = (e) => {
    if (esPreview) {
      e.preventDefault()
      return false
    }
    if (onClick) {
      onClick(e)
    }
  }

  return (
    <a
      href={esPreview ? '#' : enlace.url}
      target={esPreview ? '_self' : '_blank'}
      rel="noopener noreferrer"
      className={`block w-full ${className}`}
      onClick={handleClick}
    >
      {children}
    </a>
  )
}

// Componente para mostrar la imagen del enlace
export const ImagenEnlace = ({ enlace, estilosMiniatura = false, mostrarIcono = true }) => {
  const tamañoImagen = estilosMiniatura ? 'w-8 h-8' : (enlace.mostrarFotoGrande ? 'w-32 h-32' : 'w-12 h-12')
  const tamañoIcono = estilosMiniatura ? 'w-4 h-4' : 'w-6 h-6'

  if (enlace.imagen) {
    return (
      <div className="relative">
        <div className={`${tamañoImagen} rounded-lg overflow-hidden border-2 border-gray-200`}>
          <Image
            src={enlace.imagen}
            alt={enlace.titulo}
            className="w-full h-full object-cover"
            fallbackSrc="/api/placeholder/48/48"
          />
        </div>
        {mostrarIcono && enlace.icono && (
          <div className={`absolute -bottom-1 -right-1 ${tamañoIcono} bg-blue-100 rounded-full flex items-center justify-center border-2 border-white`}>
            <span className={estilosMiniatura ? "text-xs" : "text-sm"}>
              {renderIcon(enlace.icono)}
            </span>
          </div>
        )}
      </div>
    )
  }

  if (enlace.icono) {
    return (
      <div className={`${tamañoImagen} bg-blue-100 rounded-full flex items-center justify-center`}>
        <span className={estilosMiniatura ? "text-xs" : "text-xl"}>
          {renderIcon(enlace.icono)}
        </span>
      </div>
    )
  }

  return null
}

// Componente para mostrar el precio
export const PrecioEnlace = ({ enlace, estilosMiniatura = false }) => {
  if (!enlace.precio || !enlace.divisa) return null

  // Calcular precio final con descuento
  const precioOriginal = parseFloat(enlace.precio) || 0
  const descuento = parseFloat(enlace.descuento) || 0
  const precioFinal = descuento > 0 ? precioOriginal * (1 - descuento / 100) : precioOriginal
  const tieneDescuento = descuento > 0

  // Clases según tamaño
  const clasesPrecio = estilosMiniatura 
    ? 'text-sm font-bold' 
    : 'text-lg font-bold'
  
  const clasesDescuento = estilosMiniatura 
    ? 'text-xs' 
    : 'text-sm'

  return (
    <div className="flex flex-col gap-1">
      {/* Precio final */}
      <div className={`${clasesPrecio} text-green-700 bg-green-100 px-3 py-2 rounded-lg font-bold`}>
        💰 {formatearPrecio(precioFinal, enlace.divisa)}
      </div>
      
      {/* Información de descuento */}
      {tieneDescuento && (
        <div className="flex items-center gap-2">
          <span className={`${clasesDescuento} text-red-600 font-semibold bg-red-100 px-2 py-1 rounded-full`}>
            -{descuento.toFixed(1)}% OFF
          </span>
          <span className={`${clasesDescuento} text-gray-500 line-through`}>
            {formatearPrecio(precioOriginal, enlace.divisa)}
          </span>
        </div>
      )}
    </div>
  )
}

// Componente específico para enlaces de ubicación
export const EnlaceUbicacion = ({ enlace, estilosMiniatura = false, esPreview = false }) => {
  const handleClick = (e) => {
    if (esPreview) {
      e.preventDefault()
      return false
    }
  }

  const obtenerEnlaceGoogleMaps = () => {
    if (enlace.enlaceGoogleMaps) {
      return enlace.enlaceGoogleMaps
    }
    if (enlace.direccion) {
      return `https://maps.google.com/maps?q=${encodeURIComponent(enlace.direccion)}`
    }
    if (enlace.latitud && enlace.longitud) {
      return `https://maps.google.com/maps?q=${enlace.latitud},${enlace.longitud}`
    }
    return '#'
  }

  const nombreLugar = enlace.nombreLugar || enlace.titulo || 'Ubicación'
  const direccion = enlace.direccion || 'Ver ubicación en Google Maps'

  if (estilosMiniatura) {
    return (
      <a
        href={esPreview ? '#' : obtenerEnlaceGoogleMaps()}
        target={esPreview ? '_self' : '_blank'}
        rel="noopener noreferrer"
        onClick={handleClick}
        className="block w-full"
      >
        <div className="bg-gradient-to-r from-red-50 to-orange-50 border border-red-200 rounded-lg p-2 hover:from-red-100 hover:to-orange-100 transition-all duration-200 group">
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 bg-red-500 rounded-full flex items-center justify-center text-white">
              <i className="fas fa-map-marker-alt text-xs"></i>
            </div>
            <div className="flex-1 min-w-0">
              <h3 className="font-semibold text-gray-800 group-hover:text-red-600 transition-colors text-xs leading-tight truncate">
                {nombreLugar}
              </h3>
              <p className="text-gray-600 text-xs truncate">
                {direccion}
              </p>
            </div>
            <div className="flex-shrink-0">
              <i className="fas fa-external-link-alt text-gray-400 group-hover:text-red-500 transition-colors text-xs"></i>
            </div>
          </div>
        </div>
      </a>
    )
  }

  return (
    <a
      href={esPreview ? '#' : obtenerEnlaceGoogleMaps()}
      target={esPreview ? '_self' : '_blank'}
      rel="noopener noreferrer"
      onClick={handleClick}
      className="block w-full"
    >
      <div className="bg-gradient-to-r from-red-50 to-orange-50 border-2 border-red-200 rounded-xl p-6 hover:from-red-100 hover:to-orange-100 hover:border-red-300 hover:shadow-lg transition-all duration-300 group">
        <div className="flex items-start gap-4">
          {/* Icono de mapa */}
          <div className="w-16 h-16 bg-gradient-to-br from-red-500 to-orange-500 rounded-xl flex items-center justify-center text-white shadow-lg">
            <i className="fas fa-map-marker-alt text-2xl"></i>
          </div>
          
          {/* Contenido */}
          <div className="flex-1">
            <div className="flex items-center gap-2 mb-2">
              <h3 className="font-bold text-gray-800 group-hover:text-red-600 transition-colors text-xl">
                {nombreLugar}
              </h3>
              <div className="bg-red-100 text-red-700 px-2 py-1 rounded-full text-xs font-medium">
                📍 Ubicación
              </div>
            </div>
            
            <div className="flex items-center gap-2 mb-3">
              <i className="fas fa-map-marker-alt text-gray-500"></i>
              <p className="text-gray-600 text-sm">
                {direccion}
              </p>
            </div>
            
            {/* Información adicional */}
            <div className="flex items-center gap-4 text-sm text-gray-500">
              {enlace.horarios && (
                <div className="flex items-center gap-1">
                  <i className="fas fa-clock text-xs"></i>
                  <span>{enlace.horarios}</span>
                </div>
              )}
              {enlace.telefono && (
                <div className="flex items-center gap-1">
                  <i className="fas fa-phone text-xs"></i>
                  <span>{enlace.telefono}</span>
                </div>
              )}
            </div>
            
            {/* Botón de acción */}
            <div className="mt-4 flex items-center gap-2">
              <div className="bg-red-500 text-white px-4 py-2 rounded-lg text-sm font-medium group-hover:bg-red-600 transition-colors inline-flex items-center gap-2">
                <i className="fas fa-directions"></i>
                Cómo llegar
              </div>
              <div className="text-gray-500 text-sm">
                • Se abrirá en Google Maps
              </div>
            </div>
          </div>
          
          {/* Flecha */}
          <div className="flex-shrink-0">
            <i className="fas fa-external-link-alt text-gray-400 group-hover:text-red-500 transition-colors text-xl"></i>
          </div>
        </div>
      </div>
    </a>
  )
}

// Componente base avanzado que centraliza toda la lógica de layout
export const EnlaceBase = ({ 
  enlace, 
  estilosMiniatura = false, 
  esPreview = false,
  configuracion = {},
  children,
  className = "",
  onClick
}) => {
  // Configuración por defecto
  const config = {
    // Layout
    layout: 'condicional', // 'condicional' | 'compacto' | 'tradicional'
    mostrarDescripcion: true,
    mostrarPrecio: true,
    mostrarBoton: false, // Eliminado - ya no se usa
    
    // Estilos
    tamañoIcono: 'mediano', // 'pequeño' | 'mediano' | 'grande'
    separadores: false,
    numeracion: false,
    
    // Colores y temas
    tema: 'default', // 'default' | 'modern' | 'card' | 'button' | 'lista' | 'compact'
    
    // Comportamiento
    hoverEfectos: true,
    animaciones: true,
    
    ...configuracion
  }

  // Determinar el layout basado en la configuración y el contenido
  const determinarLayout = () => {
    if (config.layout === 'compacto') return 'compacto'
    if (config.layout === 'tradicional') return 'tradicional'
    
    // Layout condicional: foto grande = tradicional, sin foto = compacto
    return (enlace.mostrarFotoGrande && enlace.imagen) ? 'tradicional' : 'compacto'
  }

  const layout = determinarLayout()

  // Clases base según el tema
  const obtenerClasesTema = () => {
    const base = "group transition-all duration-200"
    
    switch (config.tema) {
      case 'modern':
        return `${base} bg-gradient-to-r from-blue-50 to-purple-50 border-2 border-blue-200 rounded-xl px-4 py-1 sm:p-6 hover:from-blue-100 hover:to-purple-100 hover:border-blue-300 hover:shadow-lg`
      case 'card':
        return `${base} bg-white border-2 border-gray-200 rounded-lg px-3 py-1 sm:p-4  hover:border-blue-500 hover:shadow-md`
      case 'button':
        return `${base} bg-gradient-to-r from-blue-500 to-blue-600 hover:from-blue-600 hover:to-blue-700 text-white rounded-lg px-3 py-1 sm:p-4 hover:shadow-lg transform hover:scale-105`
      case 'lista':
        return `${base} bg-gray-50 border border-gray-200 rounded-md px-3 py-1 hover:bg-gray-100 hover:border-gray-300`
      case 'compact':
        return `${base} bg-white border-b border-gray-100 py-2 px-3 py-1 hover:bg-gray-50 last:border-b-0`
      default:
        return `${base} bg-white border border-gray-200 rounded-lg px-3 py-1 hover:border-blue-300 hover:shadow-sm`
    }
  }

  // Clases para el icono/imagen
  const obtenerClasesIcono = () => {
    const base = "flex-shrink-0"
    
    if (enlace.imagen) {
      const tamaño = estilosMiniatura ? 'w-8 h-8' : (enlace.mostrarFotoGrande ? 'w-32 h-32' : 'w-12 h-12')
      return `${base} ${tamaño}`
    }
    
    const tamaños = {
      pequeño: estilosMiniatura ? 'w-2 h-2' : 'w-2 h-8',
      mediano: estilosMiniatura ? 'w-8 h-8' : 'w-12 h-12',
      grande: estilosMiniatura ? 'w-8 h-8' : 'w-13 h-13'
    }
    return `${base} ${tamaños[config.tamañoIcono]}`
  }

  // Clases para el título
  const obtenerClasesTitulo = () => {
    const base = "font-semibold transition-colors"
    const tamaños = {
      pequeño: estilosMiniatura ? 'text-xs' : 'text-sm',
      mediano: estilosMiniatura ? 'text-sm' : 'text-base',
      grande: estilosMiniatura ? 'text-base' : 'text-lg'
    }
    
    const colores = {
      default: 'text-gray-800 group-hover:text-blue-600',
      modern: 'text-gray-800 group-hover:text-blue-600',
      card: 'text-gray-800 group-hover:text-blue-600',
      button: 'text-white',
      lista: 'text-gray-800 group-hover:text-blue-600',
      compact: 'text-gray-800 group-hover:text-blue-600'
    }
    
    return `${base} ${tamaños[config.tamañoIcono]} ${colores[config.tema]}`
  }

  // Clases para la descripción
  const obtenerClasesDescripcion = () => {
    const base = "transition-colors"
    const tamaños = {
      pequeño: estilosMiniatura ? 'text-xs' : 'text-xs',
      mediano: estilosMiniatura ? 'text-xs' : 'text-sm',
      grande: estilosMiniatura ? 'text-sm' : 'text-sm'
    }
    
    const colores = {
      default: 'text-gray-600',
      modern: 'text-gray-600',
      card: 'text-gray-600',
      button: 'text-blue-100',
      lista: 'text-gray-600',
      compact: 'text-gray-500'
    }
    
    return `${base} ${tamaños[config.tamañoIcono]} ${colores[config.tema]}`
  }


  // Renderizar el contenido según el layout
  const renderizarContenido = () => {
    const tieneFotoGrande = enlace.mostrarFotoGrande && enlace.imagen
    const tieneDescripcion = config.mostrarDescripcion && enlace.descripcion
    const tienePrecio = config.mostrarPrecio && enlace.tipo === 'producto'

    if (layout === 'compacto') {
      return (
        <div className="flex items-start gap-3">
          {/* Icono/Imagen */}
          <div className={obtenerClasesIcono()}>
            <ImagenEnlace 
              enlace={enlace} 
              estilosMiniatura={estilosMiniatura}
              mostrarIcono={false}
            />
          </div>
          
          {/* Contenido */}
          <div className="flex-1 flex flex-col gap-2">
            {/* Descripción a la derecha del icono */}
            {tieneDescripcion && (
              <p className={obtenerClasesDescripcion()}>
                {enlace.descripcion}
              </p>
            )}
            
            {/* Precio */}
            {tienePrecio && (
              <PrecioEnlace enlace={enlace} estilosMiniatura={estilosMiniatura} />
            )}
            
            {/* Botón eliminado - ya no se muestra */}
          </div>
        </div>
      )
    }

    // Layout tradicional
    return (
      <div className="space-y-3">
        {/* Icono/Imagen y contenido en línea */}
        <div className="flex items-start gap-3">
          <div className={obtenerClasesIcono()}>
            <ImagenEnlace 
              enlace={enlace} 
              estilosMiniatura={estilosMiniatura}
              mostrarIcono={false}
            />
          </div>
          
          <div className="flex-1 flex flex-col gap-2">
            {/* Precio */}
            {tienePrecio && (
              <PrecioEnlace enlace={enlace} estilosMiniatura={estilosMiniatura} />
            )}
            
          </div>
        </div>
        
        {/* Descripción abajo */}
        {tieneDescripcion && (
          <p className={obtenerClasesDescripcion()}>
            {enlace.descripcion}
          </p>
        )}
      </div>
    )
  }

  return (
    <ComponenteBaseEnlace
      enlace={enlace}
      estilosMiniatura={estilosMiniatura}
      esPreview={esPreview}
      className={`${obtenerClasesTema()} ${className}`}
      onClick={onClick}
    >
      <div className={`${config.separadores ? 'border-b border-gray-100 last:border-b-0' : ''}`}>
        {/* Numeración */}
        {config.numeracion && (
          <div className="flex items-center gap-2 mb-2">
            <span className="text-lg text-gray-500 font-mono">
              {/* El índice se pasa desde el componente padre */}
            </span>
          </div>
        )}
        
        {/* Título */}
        <h3 className={`${obtenerClasesTitulo()} mb-1`}>
          {enlace.titulo}
          {enlace.url && (
            <span className="text-xs text-gray-500 ml-2 font-normal">
              • {extraerNombrePagina(enlace.url)}
            </span>
          )}
        </h3>
        
        {/* Contenido principal */}
        {children || renderizarContenido()}
      </div>
    </ComponenteBaseEnlace>
  )
}

// Hook personalizado para obtener la configuración del diseño
export const useDiseñoConfig = (diseño, configuracionPersonalizada = {}) => {
  const configuracionesBase = {
    card: {
      tema: 'card',
      layout: 'condicional',
      mostrarDescripcion: true,
      mostrarPrecio: true,
      mostrarBoton: false, // Eliminado
      tamañoIcono: 'mediano',
      hoverEfectos: true,
      animaciones: true
    },
    modern: {
      tema: 'modern',
      layout: 'condicional',
      mostrarDescripcion: true,
      mostrarPrecio: true,
      mostrarBoton: false, // Eliminado
      tamañoIcono: 'grande',
      hoverEfectos: true,
      animaciones: true
    },
    button: {
      tema: 'button',
      layout: 'compacto',
      mostrarDescripcion: true,
      mostrarPrecio: true,
      mostrarBoton: false, // El botón es el contenedor completo
      tamañoIcono: 'mediano',
      hoverEfectos: true,
      animaciones: true
    },
    lista: {
      tema: 'lista',
      layout: 'condicional',
      mostrarDescripcion: true,
      mostrarPrecio: true,
      mostrarBoton: false, // Eliminado
      tamañoIcono: 'mediano',
      separadores: true,
      hoverEfectos: true,
      animaciones: true
    },
    compact: {
      tema: 'compact',
      layout: 'condicional',
      mostrarDescripcion: false, // Se puede activar con configuracionPersonalizada
      mostrarPrecio: true,
      mostrarBoton: false, // Eliminado
      tamañoIcono: 'pequeño',
      separadores: true,
      hoverEfectos: true,
      animaciones: true
    }
  }

  return {
    ...configuracionesBase[diseño] || configuracionesBase.card,
    ...configuracionPersonalizada
  }
}

// Los exports se realizan individualmente arriba 